import {
  CharIterator2h6gbyxoj1es2 as CharIterator,
  IntIteratordtlvcwxsuu5a as IntIterator,
} from '../collections/PrimitiveIterators.mjs';
import {
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
  Char__compareTo_impl_ypi4mb3bl0kdwnivnp6 as Char__compareTo_impl_ypi4mb,
} from '../Char.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../exceptions.mjs';
import { numberToChar93r9buh19yek as numberToChar } from '../js/numberConversion.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CharProgressionIteratorClass;
function CharProgressionIterator() {
  if (CharProgressionIteratorClass === VOID) {
    class $ extends CharIterator() {
      constructor(first, last, step) {
        super();
        this.zp_1 = step;
        var tmp = this;
        // Inline function 'kotlin.code' call
        tmp.aq_1 = Char__toInt_impl_vasixd(last);
        this.bq_1 = this.zp_1 > 0 ? Char__compareTo_impl_ypi4mb(first, last) <= 0 : Char__compareTo_impl_ypi4mb(first, last) >= 0;
        var tmp_0 = this;
        var tmp_1;
        if (this.bq_1) {
          // Inline function 'kotlin.code' call
          tmp_1 = Char__toInt_impl_vasixd(first);
        } else {
          tmp_1 = this.aq_1;
        }
        tmp_0.cq_1 = tmp_1;
      }
      q1() {
        return this.bq_1;
      }
      uk() {
        var value = this.cq_1;
        if (value === this.aq_1) {
          if (!this.bq_1)
            throw NoSuchElementException().u6();
          this.bq_1 = false;
        } else {
          this.cq_1 = this.cq_1 + this.zp_1 | 0;
        }
        return numberToChar(value);
      }
    }
    initMetadataForClass($, 'CharProgressionIterator');
    CharProgressionIteratorClass = $;
  }
  return CharProgressionIteratorClass;
}
var IntProgressionIteratorClass;
function IntProgressionIterator() {
  if (IntProgressionIteratorClass === VOID) {
    class $ extends IntIterator() {
      constructor(first, last, step) {
        super();
        this.dq_1 = step;
        this.eq_1 = last;
        this.fq_1 = this.dq_1 > 0 ? first <= last : first >= last;
        this.gq_1 = this.fq_1 ? first : this.eq_1;
      }
      q1() {
        return this.fq_1;
      }
      vk() {
        var value = this.gq_1;
        if (value === this.eq_1) {
          if (!this.fq_1)
            throw NoSuchElementException().u6();
          this.fq_1 = false;
        } else {
          this.gq_1 = this.gq_1 + this.dq_1 | 0;
        }
        return value;
      }
    }
    initMetadataForClass($, 'IntProgressionIterator');
    IntProgressionIteratorClass = $;
  }
  return IntProgressionIteratorClass;
}
//region block: exports
export {
  CharProgressionIterator as CharProgressionIterator34nq4ujuknl08,
  IntProgressionIterator as IntProgressionIterator2ovd1ctrmu51n,
};
//endregion

//# sourceMappingURL=ProgressionIterators.mjs.map
